import { defineStore } from 'pinia'
import { store } from '../index'
import { get } from 'http'

export const useCommonStore = defineStore({
  id: 'Common',
  state: () => ({
    loginPageSetting: null as any,
    portalPageSetting: null as any,
    serviceSetting: {},
    agentSettings: '',
    agentEnable: false
  }),
  getters: {
    getServiceSettings(): any {
      return this.serviceSetting
    },
    getAgentSettings(): any {
      return this.agentSettings
    },
    getAgentEnable(): any {
      return this.agentEnable
    }
  },
  actions: {
    setLoginPageSetting(payload: any) {
      console.log('setLoginPageSetting:', payload)
      this.loginPageSetting = payload
    },
    setPortalPageSetting(payload: any) {
      console.log('setPortalPageSetting:', payload)
      this.portalPageSetting = payload
    },
    setServiceSetting(payload: any) {
      console.log('setServiceSetting:', payload)
      this.serviceSetting[payload.service_type] = payload
    },
    delServiceSetting(payload: any) {
      console.log('delServiceSetting:', payload)
      delete this.serviceSetting[payload]
    },
    setAgentSettings(payload: any) {
      this.agentSettings = payload
    },
    setAgentEnable(payload: any) {
      this.agentEnable = payload
    }
  }
})

export const useCommonStoreWithOut = () => {
  return useCommonStore(store)
}
